<template>

  <Dialog :closable="false" :header="translate('picklist.header.profile.wizard')"
          :style="{width: '80vw', height: '80vw'}" :visible="isDialogVisible" modal v-on:show="getData">
    <div>
      <label> {{ translate("Export.Profile") }}</label>
      <InputText v-model="profile.profileName" :placeholder="translate('placeholder.profile.name')"
                 :style="{marginBottom : '20px', marginTop : '10px', marginLeft:'10px'}"></InputText>
      <TabView :style="{height: '30vw'}">
        <TabPanel :header="translate('picklist.tab.multiavail')">
          <PickList v-model="profile.profileContent" dataKey="id" listStyle="height:342px">
            <template #sourceHeader>
              {{ translate("header.selected") }}
            </template>
            <template #targetHeader>
              {{ translate("header.available") }}
            </template>
            <template #item="slotProps">
              <div>{{ slotProps.item.label }} <span class="invalid" v-if="slotProps.item.invalid === true"> (deleted) </span></div>
            </template>
          </PickList>
          <Dialog :header="translate('header.save.Profile')" :modal="true" :style="{width: '50vw'}"
                  :visible.sync="saveDialogVisible">
            {{ message }}
            <template #footer>
              <Button :label="translate('button.Okey')" class="p-button-primary" icon="pi pi-check"
                      @click="saveDialogVisible = false"/>
            </template>
          </Dialog>
        </TabPanel>
      </TabView>
    </div>
    <template #footer>
      <Button :label="translate('button.close')" icon="pi pi-times" @click="closeDialog"/>
      <Button :label="translate('button.save')" icon="pi pi-check" @click="saveClick()"/>
    </template>

  </Dialog>

</template>

<script>
import AXIOS from '@/services/axiosClient'
import {mapActions, mapGetters} from 'vuex'
import TranslateService from "../services/translate.service";
import PicklistService from "@/services/picklist.service";

export default {
  name: "PickListExport",
  components: {},

  data() {
    return {
      picklistFieldname: "EXPORT_PROFILE",
      message: "",
      saveDialogVisible: false,
      searchProfileSelection: null,
      gridProfileSelection: null,
      profile: {
        profileName: "",
        fieldName: this.picklistFieldname,
        profileContent: [[], []],
        published: false
      }
    }
  },
  computed: {
    ...mapGetters('exportpro', ['isDialogVisible', "getCurrentProfile"])
  },
  methods: {
    ...mapActions('exportpro', [
      'addProfile',
      'closeDialog',
    ]),
    translate(key) {
      return TranslateService.translateMessage(key);
    },



    getData() {
      AXIOS.get("/gridProfiles/getAvailableFields/avail.multiavailgrid")
          .then(res => {
            let dynamicFields = [];
            let count = 1;
            // console.log("Setting dynamic fields", res.data.dynamicFields);
            for (let value of res.data.dynamicFields) {
              dynamicFields.push({
                id: count++,
                label: value.fieldLabel,
                fieldName: value.fieldName
              });
            }

            let currentProfile = this.getCurrentProfile;
            if (currentProfile != null) {
              this.profile = { ...currentProfile };

              this.profile.profileContent = PicklistService.mergeDynamicFields(
                  JSON.parse(this.profile.profileContent),
                  dynamicFields
              );
            } else {
              this.profile = {
                profileName: "",
                fieldName: this.picklistFieldname,
                profileContent: [[], dynamicFields]
              };
            }
          })
          .catch(() => {
            console.log("failed to get data");
          });
    },







    // getData() {
    //   AXIOS.get('/gridProfiles/getAvailableFields/avail.multiavailgrid').then(res => {
    //         let b = []
    //         let count = 1
    //         for (let value of res.data.dynamicFields) {
    //           b.push({id: count++, label: value.fieldLabel, fieldName: value.fieldName})
    //         }
    //     let currentProfile = this.getCurrentProfile;
    //     if (currentProfile != null) {
    //       this.profile = {...currentProfile}
    //       this.profile.profileContent = PicklistService.mergeDynamicFields(JSON.parse(this.profile.profileContent)[0],b)
    //     } else {
    //       this.profile = {
    //         profileName: "",
    //         fieldName: this.picklistFieldname,
    //         profileContent: [[], b]
    //       }
    //
    //
    //
    //
    //     }
    //       }
    //   ).catch(() => {
    //     console.log("failed to get data")
    //   })
    //
    //
    // },
    saveClick() {
      if (this.profile.profileName == "") {
        this.message = "Please name your profile"
        this.saveDialogVisible = true
      } else if (this.profile.profileContent[0].length === 0) {
        this.message = "Please select at least one availability"
        this.saveDialogVisible = true
      } else {
        this.profile.profileContent = PicklistService.filterInvalidContentsFromContent(this.profile.profileContent)
        this.profile.profileContent = JSON.stringify(this.profile.profileContent)
        this.addProfile({...this.profile})
        this.profile.profileName = ""
        this.profile.profileContent = [[], []]
        this.closeDialog();
      }
    },
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped>
.invalid{
  color: rgba(255, 0, 0, 0.94);
}
</style>